<template lang="pug">
  .tuple-container
    .search
    .list-wrapper
      .head
        .head-left 合约
      ul(class="list")
        li(v-for="item in list" 
           :class="item.selected ? 'active' : null"
           @click="handleChangeItem(item)")
          .instrumentId {{item.alias}}
</template>

<script>
import { getTupleList } from 'api/futures';
import * as R from 'ramda';

export default {
  props: {
    currency: {
      type: String,
      default: 'USD',
    },
    cycle: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      iptVal: '',
      list: [],
    };
  },
  computed: {
    renderList() {
      return this.list.filter((item) => item.instrumentId.indexOf(this.iptVal) !== -1);
    },
  },
  watch: {
    $route() {
      this.queryList();
    },
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      getTupleList({
        quoteCurrency: this.currency,
        cycle: this.cycle,
      })
        .then((res) => {
          if (res.code === 0 && res.data) {
            // let selected = null;
            this.list = res.data.currencyList;
            this.list = R.map(R.assoc('selected', false))(this.list);
            const quote = this.$route.params.cycle.split('-')[0];
            this.list.forEach((item) => {
              if (quote.toLowerCase() === item.currency.split('-')[0].toLowerCase()) {
                item.selected = true;
                // selected = { ...item };
              }
            });
            // this.$emit('change', selected);
          } else {
            this.$message.error('获取到币对失败');
          }
        })
        .catch((ex) => this.$message.error(ex.message || '获取币对列表发生错误'));
    },
    handleChangeItem(selected) {
      if (selected.selected) return;
      this.$emit('change', selected);
      const chkSele = R.ifElse(
        R.eqProps('instrumentId', selected),
        R.assoc('selected', true),
        R.assoc('selected', false),
      );
      this.list = R.map(chkSele)(this.list);
      this.$router.replace(
        `/futures-${this.currency.toLowerCase()}/${selected.currency.split('-')[0].toLowerCase()}-${
          this.$route.params.cycle.split('-')[1]
        }`,
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/consts.less';

.tuple-container {
  display: block;
  font-size: 14px;
  width: 100%;
  .search {
  }
  .list-wrapper {
    border: none;
    border-radius: 0 0 4px 4px;
    padding-bottom: 10px;
    padding-top: 1px;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 200px;
      height: 26px;
      font-size: 12px;
      .head-left {
        padding-left: 28px;
        height: 18px;
        line-height: 18px;
      }
      .head-right {
        padding-right: 12px;
      }
    }
    .list {
      height: 324px;
      overflow: auto;
      li {
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        height: 36px;
        line-height: 36px;
        padding: 0 8px;
        cursor: pointer;
        user-select: none;
        .instrumentId {
          height: 21px;
          line-height: 21px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .change {
          position: absolute;
          font-size: 12px;
          right: 8px;
        }
        .green {
          color: #2ead65;
        }
        .red {
          color: #e35e5e;
        }
      }
      .active {
        background: rgba(64, 158, 255, 0.05);
        box-shadow: inset 3px 0 0 0 @themeColor;
      }
    }
  }
}
</style>
